import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { integrationService } from '../services/integrations.service';

/**
 * Hook para autenticar con YPF.
 *
 * @returns La mutation para autenticar con YPF.
 */
export const useAuthYpf = (): UseMutationResult<any, Error, void> => {
    return useMutation<any, Error, void>({
        mutationFn: async () => {
            const response = await integrationService.authorizeWithYPF();
            return response;
        },
    });
};
